import * as React from 'react';
import { IconButton, Paper } from '@mui/material';
import PropTypes from 'prop-types';
import { Typography } from '@mui/material';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell, { tableCellClasses } from '@mui/material/TableCell';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import TableContainer from '@mui/material/TableContainer';
import TablePagination from '@mui/material/TablePagination';
import Modal from '@mui/material/Modal';
import Button from '@mui/material/Button';
import MonitorIcon from '@mui/icons-material/Monitor';
import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';
import { CircularProgress } from '@mui/material';
import Box from '@mui/material/Box';
import { Grid } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { useLocation } from "react-router-dom"
import { styled } from '@mui/material/styles';
import { getStorage, ref, listAll, deleteObject } from "firebase/storage";
import { db } from '../../Environment/firebase';
import { doc, deleteDoc } from "firebase/firestore";

type TitleType = {
  children:string
}

function Title(props:TitleType) {
    return (
      <Typography component="h2" variant="h6" color="primary" gutterBottom>
        {props.children}
      </Typography>
    );
  }
  
  Title.propTypes = {
    children: PropTypes.node,
  };
  
  const StyledTableCell = styled(TableCell)(({ theme }) => ({
    [`&.${tableCellClasses.head}`]: {
        backgroundColor: theme.palette.common.black,
        color: theme.palette.common.white,
    },
    [`&.${tableCellClasses.body}`]: {
        fontSize: 24,
    },
}));

// Generate Order Data
export function createCaseTableData(id:string,title:string,patientId:string, sites:string[] , modality:string ,date:string, tags:string[] ) {
  return { id,title,patientId, sites , modality ,date, tags};
}

function textTrim(targetTextArr:string | string[],wordCount = 8) {
  // テキストをトリミングする要素
  if(targetTextArr){
    let selector;
    if(typeof targetTextArr === 'string'){
      selector =  targetTextArr
    }else{
      selector =  targetTextArr.join(',');
    }
    

    // 文末に追加したい文字
    var clamp = '…';

      if(selector.length>wordCount){
        selector = selector.slice(0,wordCount - 1)
        selector += clamp;
      }
 
    return selector
  }else{
    return targetTextArr
  }
}

export type CaseTableType = {
  rows:{
    id:string,
    title:string, 
    patientId:string,
    sites:string[], 
    modality:string,
    date:string,
    tags:string[]}[]
  management:boolean
}


export default function CaseTable(props:CaseTableType){
    const rows = props.rows;
    const management = props.management? props.management : false;

    const editor = management? 'Edit' : 'Viewer';

    const uploaderId = 'df0090fb-934e-11ee-96c4-f938a98198c2';
    const navigate = useNavigate();
    const location = useLocation();
    const [page, setPage] = React.useState<number>(location.state?.page as number || 0);
    const [modalOpen,setModalOpen]= React.useState(false);
    const [deleteWating,setDeleteWaitig]= React.useState(false);
    const [dense, setDense] = React.useState(false);
    const [deleteRow,setDeleteRow]= React.useState({id:'',title:'', sites:'',modality:'' ,date:'', tags:[]});
    const [rowsPerPage, setRowsPerPage] = React.useState(location.state?.rowsPerPage as number || 5);

    const Modalstyle = {
      position: 'absolute',
      top: '50%',
      left: '50%',
      transform: 'translate(-50%, -50%)',
      width: 400,
      bgcolor: 'background.paper',
      border: '2px solid #000',
      boxShadow: 24,
      pt: 2,
      px: 4,
      pb: 3,
    };

    const handleChangePage = (event: unknown, newPage:number) => {
        setPage(newPage);
      };
    
    const handleChangeRowsPerPage = (event:React.ChangeEvent<HTMLInputElement>) => {
      setRowsPerPage(parseInt(event.target.value, 10));
      setPage(0);
    };

    
    return(
        <React.Fragment>
            <Title>Result</Title>
            <Paper sx={{ width: '100%', mb: 2 }}>
                <TableContainer>
                    <Table
                    sx={{ minWidth: 740 }}
                    aria-labelledby="tableTitle"
                    size={dense ? 'small' : 'medium'}
                    >
                    <TableHead>
                    <TableRow>
                        {management?
                          <StyledTableCell align="center">patientId</StyledTableCell>:
                          <StyledTableCell align='center'>Title</StyledTableCell>
                        }
                        <StyledTableCell align='center'>部位名</StyledTableCell>
                        <StyledTableCell align="center">モーダル</StyledTableCell>
                        <StyledTableCell align="center">アップロード日</StyledTableCell>
                        <StyledTableCell align="center">タグ情報</StyledTableCell>
                        <StyledTableCell align="center">{editor}</StyledTableCell>
                    </TableRow>
                    </TableHead>                   
                    {rows.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                        .map((row,index) => {
                          var url:string;
                          if(management){
                            url = `/manage/catalogue/${uploaderId}/${row.id}`
                          }else{
                            url = `/catalogue/${uploaderId}/${row.id}`
                          }
                    return(
                    <TableBody>
                    <TableRow key={row.id} >
                        {management?
                        <TableCell align='center'>{row.title}</TableCell>:
                        <TableCell align='center'>{row.patientId}</TableCell>
                        }
                        <TableCell align='center'>{textTrim(row.sites)}</TableCell>
                        <TableCell align='center'>{textTrim(row.modality)}</TableCell>
                        <TableCell align='center'>{row.date}</TableCell>
                        <TableCell align='center'>{textTrim(row.tags)}</TableCell>
                        <TableCell align='center' onClick={()=>navigate(url, { state: { page: page, rowsPerPage:rowsPerPage} })}>
                          <IconButton aria-haspopup="true">
                            {management? <EditIcon color='success'/>:<MonitorIcon color='primary'/>}
                          </IconButton>
                        </TableCell>
                    </TableRow>
                    </TableBody>
                    )})}
                    
                    </Table>
                </TableContainer>
                <TablePagination
                    rowsPerPageOptions={[5, 10, 25]}
                    component="div"
                    count={rows.length}
                    rowsPerPage={rowsPerPage}
                    page={page}
                    onPageChange={handleChangePage}
                    onRowsPerPageChange={handleChangeRowsPerPage}
                />
            </Paper>
        </React.Fragment>
    )
}
